import React from 'react'
import PropTypes from 'prop-types'
import { isEmpty } from 'lodash'
import { Box, Chip, Paper, Typography } from '@material-ui/core'
import { BookOpen as BookOpenIcon } from 'react-feather'

import FilenameChip from '../FilenameChip'

import constants from 'constants/index'
import useStyles from './styles'

const formatCategory = (category) =>
  constants.dai.disputes.ARGUMENT_CATEGORY_LABEL[category] ||
  category?.replace(/_/g, ' ').replace(/^\w/, (c) => c.toUpperCase())

const DisputeArguments = ({ arguments: items = [] }) => {
  const classes = useStyles()

  if (isEmpty(items)) return null

  return (
    <Box>
      <Typography variant="subtitle1" className={classes.sectionTitle}>
        Argumentos da contestação
      </Typography>

      <Box className={classes.list}>
        {items.map((arg, index) => (
          <Paper
            key={index}
            variant="outlined"
            className={classes.argumentPaper}
          >
            <Box className={classes.argumentHeader}>
              <Typography className={classes.category}>
                {formatCategory(arg.category)}
              </Typography>
            </Box>

            {arg.point_excerpt && (
              <>
                <Typography className={classes.fieldLabel}>
                  Ponto contestado
                </Typography>
                <Typography className={classes.excerpt}>
                  {arg.point_excerpt}
                </Typography>
              </>
            )}

            {arg.rebuttal && (
              <>
                <Typography className={classes.fieldLabel}>
                  Argumentação
                </Typography>
                <Typography className={classes.rebuttal}>
                  {arg.rebuttal}
                </Typography>
              </>
            )}

            {arg.handbook_ref?.excerpt && (
              <>
                <Typography className={classes.fieldLabel}>
                  Referência do caderno
                  {arg.handbook_ref.requirement_id &&
                    ` (req. ${arg.handbook_ref.requirement_id})`}
                </Typography>
                <Box className={classes.handbookBox}>
                  <Typography className={classes.handbookText}>
                    {arg.handbook_ref.excerpt}
                  </Typography>
                </Box>
              </>
            )}

            {arg.legal_refs?.length > 0 && (
              <>
                <Typography className={classes.fieldLabel}>
                  Referências normativas
                </Typography>
                <Box className={classes.refsRow}>
                  {arg.legal_refs.map((ref) => (
                    <Chip
                      key={ref}
                      size="small"
                      icon={<BookOpenIcon size={12} />}
                      label={ref}
                      className={classes.legalChip}
                    />
                  ))}
                </Box>
              </>
            )}

            {!isEmpty(arg.cited_evidences) && (
              <>
                <Typography className={classes.fieldLabel}>
                  Evidências citadas
                </Typography>
                <Box className={classes.refsRow}>
                  {arg.cited_evidences.map((file) => (
                    <FilenameChip key={file} filename={file} />
                  ))}
                </Box>
              </>
            )}
          </Paper>
        ))}
      </Box>
    </Box>
  )
}

DisputeArguments.propTypes = {
  arguments: PropTypes.array,
}

export default DisputeArguments
